import React from 'react';
import { useTranslation } from 'react-i18next';
import HeaderSimple from './../../components/HeaderSimple/HeaderSimple'
import { Link } from "react-router-dom";
import { ReactComponent as Arrow } from './../../../assets/svg/arrow.svg';
import './NewAccountSucess.scss'
import dogCat from '../../../assets/images/dog&cat.png'


function NewAccount() {
  const { t } = useTranslation();

  return (
    <>
      <HeaderSimple />
      <section className='new-account-sucess'>
        <div className='container'>
          <img src={dogCat} alt="" className='award' />
          <h1>{t('new-account-form-title')}</h1>
          <p>{t('new-account-form-text')}</p>
          <Link to="/home" className='row'>
            <span>{t('new-account-form-button')}</span>
          </Link>
        </div>
      </section>
    </>
  );
}

export default NewAccount;